import { InformationColors, NegativeColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';

// import { OldBreakPoints } from '@picsart/rc/enums';

const useStyles = createUseStyles<string, { titleColor?: string }>(
  {
    root: {
      backgroundColor: NegativeColors.base.default,
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      gap: Spacings.s32,
      paddingBlock: Spacings.s72,

      // [mediaQuery(900)]: {
      '@media screen and (max-width: 900px)': {
        padding: [Spacings.s56, Spacings.s24],
        alignItems: 'stretch',
      },
    },

    title: {
      color: NegativeColors.text.default,
      '& i': {
        color: ({ titleColor }) => titleColor || InformationColors.base.default,
        fontStyle: 'normal',
      },

      // [mediaQuery(900)]: {
      '@media screen and (max-width: 900px)': {
        textAlign: 'center',
      },
    },

    description: {
      maxWidth: '80%',
      color: NegativeColors.text.default,
      fontSize: FontSizes.s20,
      fontWeight: FontWeights.medium,
      lineHeight: LineHeights.l28,

      // [mediaQuery(900)]: {
      '@media screen and (max-width: 900px)': {
        maxWidth: '100%',
        textAlign: 'center',
      },
    },

    content: {
      width: '100%',
      display: 'grid',
      gridTemplateColumns: '1fr 2fr',
      gap: Spacings.s32,

      // [mediaQuery(900)]: {
      '@media screen and (max-width: 900px)': {
        gridTemplateColumns: '1fr',
      },
    },

    titleAndDescription: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s10,
    },

    imageHolder: {
      width: '100%',
      maxHeight: 500,
      minHeight: 336,
      display: 'flex',
      alignItems: 'center',
      position: 'relative',

      // [mediaQuery(480)]: {
      '@media screen and (max-width: 480px)': {
        maxHeight: 172,
      },
    },

    image: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
    picture: {
      width: '100%',
      height: '100%',
      opacity: 0,
      position: 'absolute',
      transition: 'opacity 1.5s',
    },

    visibleImage: {
      opacity: 1,
    },
    // skeleton
    wrapperSkeleton: {
      extend: 'wrapper',
      backgroundColor: 'none',
    },
    titleSkeleton: {
      extend: 'title',
      maxWidth: '100%',
      width: 500,
      height: 30,
    },
    descriptionSkeleton: {
      extend: 'description',
      width: '70%',
      height: 30,
    },
    labelSkeletonHolder: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      position: 'relative',
    },
    labelSkeleton: {
      maxWidth: '100%',
      width: 300,
      height: 30,

      // [mediaQuery(OldBreakPoints.small)]: {
      '@media screen and (max-width: 768px)': {
        position: 'absolute',
        width: '100%',
      },
    },
  },
  {
    name: 'design-for-use-cases',
  },
);

export default useStyles;
